import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ClienteUsuarioInterface, ClienteUsuarioCadastroInterface, ResetarSenhaUsuarioInterface } from "../../_interfaces/cliente.interface";

@Injectable({
  providedIn: 'root'
})

export class UsuarioService {
  private _apiUrl: string;

  constructor(private http: HttpClient) {
    this._apiUrl = `${environment.apiUrl}`
  }

  selecionarTodos() {
    return this.http.get(`${this._apiUrl}/Usuario`).toPromise();
  }

  emularUsuario(pIdUsuario: number) {
    return this.http.get(`${this._apiUrl}/Usuario/Emular/${pIdUsuario}`).toPromise();
  }

  adicionarUsuario(pObjUsuario: ClienteUsuarioCadastroInterface) {
    return this.http.post(`${this._apiUrl}/Usuario`, pObjUsuario).toPromise();
  }

  selecionarPorFkCliente(pFkCliente: number) {
    return this.http.get(`${this._apiUrl}/Usuario/SelecionarPorFkCliente/${pFkCliente}`).toPromise();
  }

  selecionarPorIdUsuario(pIdUsuario: number) {
    return this.http.get(`${this._apiUrl}/Usuario/${pIdUsuario}`).toPromise();
  }

  selecionarPorLogin(pObj: ClienteUsuarioInterface) {
    return this.http.patch(`${this._apiUrl}/Usuario/SelecionarPorLogin`, pObj).toPromise();
  }

  atualizarUsuario(pObjUsuario: ClienteUsuarioInterface) {
    return this.http.put(`${this._apiUrl}/Usuario/${pObjUsuario.idClienteUsuario}`, pObjUsuario).toPromise();
  }

  excluirUsuario(pIdUsuario: number) {
    return this.http.delete(`${this._apiUrl}/Usuario/${pIdUsuario}`).toPromise();
  }

  resetarSenha(pIdUsuario: number, pRequest: ResetarSenhaUsuarioInterface) {
    return this.http.put(`${this._apiUrl}/Usuario/ResetarSenha/${pIdUsuario}`, pRequest).toPromise();
  }

  esqueciMinhaSenha(pObjUsuario: ClienteUsuarioInterface) {
    return this.http.patch(`${this._apiUrl}/Usuario/EsqueciMinhaSenha`, pObjUsuario).toPromise();
  }
}
